var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-container",
        { staticClass: "mt-5" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "12", lg: "12" } },
                [
                  !_vm.loading
                    ? _c(
                        "b-card",
                        { staticClass: "shadow" },
                        [
                          _c("b-card-header", [
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v("Campaign Details"),
                            ]),
                          ]),
                          _c("b-card-body", [_c("CampaignDetails")], 1),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-card", [_c("b-card-body", [_c("ContentList")], 1)], 1),
      _c("b-card", [_c("b-card-body", [_c("TaskList")], 1)], 1),
      _c("b-card", [_c("b-card-body", [_c("CostList")], 1)], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }